import { createContext } from "react";

import { User } from "@/model/User/User";

export const UserContext = createContext<User | null>(null);
export const UserContextProvider = UserContext.Provider;
export const UserContextConsumer = UserContext.Consumer;
